import { Col, Row } from 'antd';
import dayjs from 'dayjs';
import Image from 'next/image';
import Link from 'next/link';
import { ReactElement } from 'react';
import styled from 'styled-components';

import FiveIdeas from '../../assets/images/LandingPage/5-Ideas.png';
import fivetipsraw from '../../assets/images/LandingPage/5tipsraw.jpg';
import BrainstormingGroup from '../../assets/images/LandingPage/brainstorming-group.png';
import EdtechCover from '../../assets/images/LandingPage/edtech_cover_photo.png';
import HybridMeetings from '../../assets/images/LandingPage/hybrid-meetings-raw.jpg';
import Jens from '../../assets/images/LandingPage/jens.png';
import LarsBerton from '../../assets/images/LandingPage/lars_berton.jpg';
import NHH from '../../assets/images/LandingPage/nhh.png';
import theme from '../../assets/theme';
import { Center } from '../../components/_atoms/Center';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import CoreAPIService from '../../services/CoreAPIService';
import { BlogPost } from '../../services/CoreAPIService/CoreAPIService';

const staticBlogposts = [
  {
    id: 14,
    title: '5 Steps to Get Stakeholder Buy-in for a New Idea',
    description:
      'Next time you need to get stakeholder buy-in for an idea, consider trying these 5 steps. ',
    date: '2022-07-01',
    path: '/blog/5-Steps-to-Get-Stakeholder-Buy-in-for-a-New-Idea',
    image: fivetipsraw,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 13,
    title: 'The complete guide to online brainstorming and ideation',
    description:
      'Online brainstorming helps you bring out the best ideas from your team, so you can make better decisions together. But organising it can be difficult. How do you make sure everyone’s heard? And how do you avoid a logistical nightmare?',
    date: '2022-06-28',
    path: '/blog/the-complete-guide-to-online-brainstorming-and-ideation',
    image: BrainstormingGroup,
    imageAltText: 'Group of people brainstorming together',
  },
  {
    id: 12,
    title: '5 tips to handle the workplace challenge of this decade: Hybrid meetings',
    description: '',
    date: '2022-06-17',
    path:
      '/blog/five-tips-to-handle-the-workplace-challenge-of-this-decade-hybrid-meetings',
    image: HybridMeetings,
    imageAltText: 'Hybrid meetings',
  },
  {
    id: 11,
    title: 'Why do a team health check?',
    description: 'Ensure team phsychological safety',
    date: '2022-06-17',
    path: '/blog/why-do-a-team-health-check',
    image: Jens,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 10,
    title: 'Ice breakers for sales, marketing and HR teams - not seen on Google',
    description: '',
    date: '2022-06-12',
    path: '/blog/ice-breakers-for-sales-marketing-and-HR-teams-not-seen-on-google',
    image: Jens,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 9,
    title: '17 workplace ice breaker games and activities for meetings and workshops',
    description: '',
    date: '2022-06-08',
    path:
      '/blog/17-workplace-ice-breaker-games-and-activities-for-meetings-and-workshops',
    image: Jens,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 1,
    title: 'Lars sine topp tre undervisningstips',
    description: 'Tre undervisningstips fra superunderviser Lars fra Nord universitet',
    date: '2021-12-30',
    path: '/blog/tre-undervisningstips-lars',
    image: LarsBerton,
    imageAltText: 'Lars berton',
  },
  {
    id: 2,
    title: 'Students` response to Curipod at Norwegian School of Economics (NHH)',
    description: 'Find out what sudents really think about using Curipod',
    date: '2021-12-16',
    path: '/blog/students-response-to-curipod',
    image: NHH,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 3,
    title: 'Curipod, GDPR, cloud vendors and Schrems II',
    description: 'How Curipod is handling the implications of Schrems II',
    date: '2021-11-19',
    path: '/blog/schrems2',
    image: Jens,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 4,
    title: '5 tips for å skape nysgjerrighet i klasserommet',
    description:
      'Her deler jeg noen tips til aktiviteter inspirert av alle de dyktige lærerne vi',
    date: '2021-11-12',
    path: '/blog/fem-tips-til-nysgjerrighet-i-klasserommet',
    image: FiveIdeas,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 5,
    title: '5 ways to create curiosity in the classroom',
    description:
      'Here we have collected a few activities we have learned from the teachers we speak to daily in Curipod. Big thanks to them!',
    date: '2021-11-12',
    path: '/blog/five-tips-for-curiosity',
    image: FiveIdeas,
    imageAltText: 'Jens Aarre Seip',
  },
  {
    id: 6,
    title: '36 Norske læringsteknologiselskap som endrer hvordan vi lærer',
    description:
      'Norsk læringsteknologi (edtech) skyter fart. Her finner du 36 norske edtech-selskap som brenner for læring.',
    date: '2020-05-27',
    path: '/blog/norsk-laeringsteknologi',
    image: EdtechCover,
    imageAltText: 'Jens Aarre Seip',
  },
];
const BlogPage: NextPageWithLayout<{ blogPosts: BlogPost[] }> = ({ blogPosts }) => {
  return (
    <MDContainer style={{ marginTop: 40 }}>
      {blogPosts.map(post => {
        return (
          <PostContainer key={post.id}>
            <Link href={`/blog/${post.slug}`} key={post.id} passHref>
              <StyledLink>{post.title}</StyledLink>
            </Link>
            <Row gutter={[36, 36]} style={{ marginTop: 20 }}>
              {post.cover && (
                <Col xs={24} md={24} lg={12} xl={12}>
                  <Center>
                    <Image
                      style={{ borderRadius: 10 }}
                      height="214px"
                      width="322px"
                      objectFit="cover"
                      src={post.cover}
                    />
                  </Center>
                </Col>
              )}
              {post.description && (
                <Col xs={24} md={24} lg={12} xl={12}>
                  <p>{post.description}</p>
                </Col>
              )}
            </Row>
            {post.date && <h3>{dayjs(post.date).format('YYYY-MM-DD')}</h3>}
          </PostContainer>
        );
      })}
      {staticBlogposts.map(post => {
        return (
          <PostContainer key={post.id}>
            <Link href={post.path} key={post.id} passHref>
              <StyledLink>{post.title}</StyledLink>
            </Link>
            <Row gutter={[36, 36]} style={{ marginTop: 20 }}>
              <Col xs={24} md={24} lg={12} xl={12}>
                <Center>
                  <Image style={{ borderRadius: 10 }} src={post.image} />
                </Center>
              </Col>
              <Col xs={24} md={24} lg={12} xl={12}>
                <p>{post.description}</p>
              </Col>
            </Row>
            <h3>{post.date}</h3>
          </PostContainer>
        );
      })}
    </MDContainer>
  );
};

const PostContainer = styled.div`
  margin-bottom: 80px;
`;

const MDContainer = styled.main`
  width: 680px;
  padding: 20px 0px;
  margin-left: auto;
  margin-right: auto;

  h1 {
    font-size: 60px;
    @media ${theme.device.mobileL} {
      font-size: 40px;
    }
  }
  h2 {
    font-size: 35px;
    margin-bottom: 40px;
  }

  p {
    font-size: 22px;
    line-height: 34px;
    font-weight: 450;
    /* margin-bottom: 40px; */
  }

  @media ${theme.device.laptop} {
    width: 680px;
  }
  @media ${theme.device.tablet} {
    width: 400px;
  }
  @media ${theme.device.mobileL} {
    width: 300px;
  }
`;
const StyledLink = styled.a`
  color: ${theme.colors.black};
  font-size: 28px;
  :hover {
    color: ${theme.colors.black};
  }
`;
BlogPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="Blog"
      subTitle="We write about pedagogy, communities and learning technology"
      primaryActionText="Sign up - It's free"
      hideActions
    >
      {page}
    </LandingPageLayout>
  );
};

export async function getStaticProps() {
  const posts = await CoreAPIService.fetchNotionBlogposts();
  return {
    props: {
      blogPosts: posts,
    },
  };
}

export default BlogPage;
